import { track } from '@/lib/analytics'
import { tradeVenueName } from '@/lib/analytics-format'
import store from '@/lib/configs/store-config'
import { totalBalanceUsdRawAtom } from '@/state/account'
import type { PublicAccount } from '@/types/generated/common/account'

/**
 * `Connect Exchange Account`, for a connection confirmed ACTIVE.
 *
 * `alreadyTracked` is owned by one wizard instance, so the finalize path and the
 * pending-poll effect can't both fire for the same attempt, while a later
 * reconnect (a fresh wizard) still tracks. `account_value_usd` is read once and
 * only if the balance stream already delivered it — never awaited, never
 * delaying the event.
 */
export function trackAccountConnected(account: PublicAccount, alreadyTracked: Set<string>): void {
  const exchange = tradeVenueName(account.tradeVenue)
  if (!exchange || alreadyTracked.has(account.accountId)) return
  alreadyTracked.add(account.accountId)

  const value = store.get(totalBalanceUsdRawAtom)[account.accountId]
  void track('Connect Exchange Account', {
    exchange,
    ...(typeof value === 'number' && Number.isFinite(value) ? { account_value_usd: value } : {}),
  })
}
